module.exports = __webpack_public_path__ + "img/categories-documents.04f4b270.svg";